package com.wintermar.inspection.core.ui.component.input.util

data class InputValidationErrorModel(val hasError: Boolean = false, val message: String = "") {
    companion object {
        // Simple but robust email regex: local@domain.tld (TLD min 2 chars)
        private val EMAIL_REGEX = Regex("^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}\$")
        private fun valid() = InputValidationErrorModel(false, "")
        private fun error(msg: String) = InputValidationErrorModel(true, msg)
    }

    fun validate(
        value: String,
        validation: InputValidationModel,
        label: String = "",
        mandatoryMessage: String = "",
    ): InputValidationErrorModel {
        val types = validation.types.orEmpty()
        if (types.isEmpty() || (value.isBlank() && !types.contains(InputValidationType.MANDATORY))) return valid()

        // Mandatory check (explicit flag or type)
        if ((validation.mandatory || types.contains(InputValidationType.MANDATORY)) && value.isBlank()) {
            val message = mandatoryMessage.ifEmpty { "is required" }
            return error(if (label.isBlank()) message else "$label $message")
        }

        // Minimum characters
        if (types.contains(InputValidationType.MIN_CHAR) &&
            value.length < (validation.minChar ?: 0)
        ) {
            return error("$label must be at least ${validation.minChar} characters")
        }

        // Email format
        if (types.contains(InputValidationType.EMAIL) && value.isNotEmpty() && !EMAIL_REGEX.matches(
                value
            )
        ) {
            return error("Invalid email format")
        }

        return valid()
    }
}
